// askSmart-ui/src/pages/MapleCoin/components/Flag.tsx
import { Currency } from '../types';

// Inline SVG rather than flag emoji: Windows renders 🇨🇦 as the letters "CA".
export default function Flag({ currency, size = 40 }: { currency: Currency; size?: number }) {
  const clip = `mc-flag-${currency}`;
  return (
    <svg className="mc-flag" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <defs>
        <clipPath id={clip}>
          <circle cx="12" cy="12" r="12" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clip})`}>
        {currency === 'CAD' ? (
          <>
            <rect width="24" height="24" fill="#fff" />
            <rect width="6" height="24" fill="#d52b1e" />
            <rect x="18" width="6" height="24" fill="#d52b1e" />
            <path
              fill="#d52b1e"
              d="M12 4.2l1.2 2.5 1.4-.6-.6 3.4 2-1.8.4 1.4 1.6-.4-.6 2.2 1 .6-3 2.4.4 1.2-3.2-.4v3.3h-1.2v-3.3l-3.2.4.4-1.2-3-2.4 1-.6-.6-2.2 1.6.4.4-1.4 2 1.8-.6-3.4 1.4.6z"
            />
          </>
        ) : (
          <>
            <rect width="24" height="24" fill="#fff" />
            {[0, 2, 4, 6, 8, 10, 12].map((i) => (
              <rect key={i} y={i * (24 / 13)} width="24" height={24 / 13} fill="#b22234" />
            ))}
            <rect width="11" height={(24 / 13) * 7} fill="#3c3b6e" />
            {[2.2, 5.5, 8.8].flatMap((x) =>
              [2.4, 6.4, 10.4].map((y) => <circle key={`${x}-${y}`} cx={x} cy={y} r="0.7" fill="#fff" />)
            )}
          </>
        )}
      </g>
      <circle cx="12" cy="12" r="11.5" fill="none" stroke="rgba(0,0,0,0.08)" />
    </svg>
  );
}
